import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import CarouselCard, { CarouselCardProps } from './CarouselCard/CarouselCard';
import ContentImpressionTracker from '../ContentImpressionTracker/ContentImpressionTracker';
import { IInterestResponse } from '@pages/Root/services/api/interest/interest-model-definitions.ts';
import 'swiper/css';
import 'swiper/css/free-mode';
import './Carousel.scss';

export interface CarouselProps {
  items: CarouselCardProps[];
  interests: IInterestResponse;
  slidesPerView?: number;
  spaceBetween?: number;
  className?: string;
  onCardClick?: (index: number, item: CarouselCardProps) => void;
}

const Carousel: FC<CarouselProps> = ({
  items = [],
  interests,
  slidesPerView = 1.5,
  spaceBetween = 16,
  className = '',
  onCardClick
}) => {
  const handleCardClick = (index: number, item: CarouselCardProps) => {
    if (onCardClick) {
      onCardClick(index, item);
    }
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <div className={`carousel ${className}`}>
      <Swiper
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        freeMode={true}
        modules={[FreeMode]}
        className="carousel__swiper"
        slidesOffsetBefore={20}
        slidesOffsetAfter={20}
      >
        {items.map((item, index) => {
          // Only wrap with tracker if originalItem exists
          const card = (
            <CarouselCard
              {...item}
              onClick={() => {return handleCardClick(index, item)}}
            />
          );

          return (
            <SwiperSlide key={index} className="carousel__slide">
              {item.originalItem ? (
                <ContentImpressionTracker
                  item={item.originalItem}
                  interests={interests}
                >
                  {card}
                </ContentImpressionTracker>
              ) : (
                card
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Carousel;
